var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"effects_item_upper"},[_c('a',{staticClass:"category_card",on:{"click":_vm.favoritesOpen}},[_c('div',{staticClass:"text_wrpr"},[_c('span',[_vm._v("Favorites")]),_c('span',[_vm._v(_vm._s(_vm.favoritesCount))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }